// extracted by mini-css-extract-plugin
module.exports = {"fav_button":"fav-button_fav_button__342KB","fav_button_badge":"fav-button_fav_button_badge__39RPg"};